import styled from '@emotion/styled'

import media from './../../../common/MediaQueries'
import { transition } from './../../../common/Mixins'

const GlobalBadgesStyled = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const GlobalBadgesBackgroundStyled = styled.div`
  position: relative;
`

const GlobalBadgesContentStyled = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

const GlobalBadgesListStyled = styled.ul`
  position: relative;
  width: 100%;
  height: 100%;
  > li {
    &:nth-of-type(1) {
      width: 2.125rem;
      height: 2.125rem;
      left: 8%;
      top: 32%;
      @media ${media.phone} {
        width: 4.0625rem;
        height: 4.0625rem;
      }
      @media ${media.tablet} {
        left: -2%;
        top: 19%;
      }
    }
    &:nth-of-type(2) {
      width: 2.75rem;
      height: 2.75rem;
      left: 15%;
      top: -9%;
      @media ${media.phone} {
        width: 4.5625rem;
        height: 4.5625rem;
      }
      @media ${media.tablet} {
        left: 23%;
        top: -12%;
      }
    }
    &:nth-of-type(3) {
      width: 2.125rem;
      height: 2.125rem;
      top: 20%;
      left: 29%;
      @media ${media.phone} {
        width: 4.0625rem;
        height: 4.0625rem;
      }
      @media ${media.tablet} {
        top: 41%;
        left: 22%;
      }
    }
    &:nth-of-type(4) {
      width: 2.125rem;
      height: 2.125rem;
      bottom: 21%;
      left: 17%;
      @media ${media.phone} {
        width: 3.375rem;
        height: 3.375rem;
      }
      @media ${media.tablet} {
        bottom: 5%;
        left: 17%;
      }
    }
    &:nth-of-type(5) {
      width: 2.125rem;
      height: 2.125rem;
      top: -12%;
      left: 38%;
      @media ${media.phone} {
        width: 4.0625rem;
        height: 4.0625rem;
      }
      @media ${media.tablet} {
        top: -34%;
        left: 55%;
      }
    }
    &:nth-of-type(6) {
      width: 2.6875rem;
      height: 2.6875rem;
      top: 11%;
      left: 55%;
      @media ${media.phone} {
        width: 4.5625rem;
        height: 4.5625rem;
      }
      @media ${media.tablet} {
        top: 11%;
        left: 61%;
      }
    }
    &:nth-of-type(7) {
      width: 2.6875rem;
      height: 2.6875rem;
      top: 49%;
      left: 42%;
      @media ${media.phone} {
        width: 4.0625rem;
        height: 4.0625rem;
      }
      @media ${media.tablet} {
        top: 50%;
        left: 45%;
      }
    }
    &:nth-of-type(8) {
      width: 2.125rem;
      height: 2.125rem;
      top: -3%;
      right: 9%;
      @media ${media.phone} {
        width: 4.5625rem;
        height: 4.5625rem;
      }
      @media ${media.tablet} {
        top: -25%;
        right: -1%;
      }
    }
    &:nth-of-type(9) {
      width: 2.125rem;
      height: 2.125rem;
      right: 9%;
      top: 49%;
      @media ${media.phone} {
        width: 4.0625rem;
        height: 4.0625rem;
      }
      @media ${media.tablet} {
        right: -2%;
        top: 45%;
      }
    }
    &:nth-of-type(10) {
      width: 2.125rem;
      height: 2.125rem;

      bottom: 4%;
      right: 28%;
      @media ${media.phone} {
        width: 4.5625rem;
        height: 4.5625rem;
      }
    }
  }
`

const GlobalBadgesListItemStyled = styled.li`
  ${transition}
  position: absolute;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0rem 0.625rem 0.625rem 0rem rgba(198, 200, 247, 0.42);
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    box-shadow: 0.5rem 0.625rem 0.625rem 0rem rgba(198, 200, 247, 0.42);
  }
`

export { GlobalBadgesStyled, GlobalBadgesBackgroundStyled, GlobalBadgesContentStyled, GlobalBadgesListStyled, GlobalBadgesListItemStyled }
